var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.7273C17 21.175 17.4477 20.7273 18 20.7273H19.2727C19.825 20.7273 20.2727 21.175 20.2727 21.7273V23C20.2727 23.5523 19.825 24 19.2727 24H18C17.4477 24 17 23.5523 17 23V21.7273ZM22.7273 21.7273C22.7273 21.175 23.175 20.7273 23.7273 20.7273H25C25.5523 20.7273 26 21.175 26 21.7273V23C26 23.5523 25.5523 24 25 24H23.7273C23.175 24 22.7273 23.5523 22.7273 23V21.7273ZM17 16C17 15.4477 17.4477 15 18 15H19.2727C19.825 15 20.2727 15.4477 20.2727 16V17.2727C20.2727 17.825 19.825 18.2727 19.2727 18.2727H18C17.4477 18.2727 17 17.825 17 17.2727V16ZM22.7273 16C22.7273 15.4477 23.175 15 23.7273 15H25C25.5523 15 26 15.4477 26 16V17.2727C26 17.825 25.5523 18.2727 25 18.2727H23.7273C23.175 18.2727 22.7273 17.825 22.7273 17.2727V16Z",
    fill: "#FFFDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.5V5.42308M23 5.42308L12.3111 1.29041C11.8292 1.10407 11.2938 1.11149 10.8172 1.31112L1 5.42308M23 5.42308L11.56 9.84615M1 5.42308V18.2463C1 19.0523 1.48387 19.7796 2.22734 20.091L11.56 24M1 5.42308L11.56 9.84615M11.56 24L14.2 23.1154M11.56 24V9.84615",
    stroke: "#FFFDF0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/InventoryIcon.5e6700939aef2123dd8592252c0f4a92.svg";
export { ForwardRef as ReactComponent };